/* Grove Reference: progressive enhancement; native product/cart forms work without JS. */
(() => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.getElementById('MobileMenu');
  function closeMenu() { if (!menu || !nav) return; nav.hidden = true; menu.setAttribute('aria-expanded', 'false'); }
  menu?.addEventListener('click', () => { nav.hidden = !nav.hidden; menu.setAttribute('aria-expanded', String(!nav.hidden)); });
  nav?.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && nav && !nav.hidden) { closeMenu(); menu.focus(); } });

  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-carousel]:not([data-carousel-ready])').forEach(root => {
      root.dataset.carouselReady = 'true';
      const track = root.querySelector('[data-series-track]');
      const prev = root.querySelector('[data-series-prev]');
      const next = root.querySelector('[data-series-next]');
      const status = root.querySelector('[data-series-position]');
      if (!track || !prev || !next) return;
      const cards = [...track.querySelectorAll('.series-card')];
      function update() {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.disabled = next.disabled = max < 2;
        const stride = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        const first = stride > 0 ? Math.max(1, Math.min(cards.length, Math.round(track.scrollLeft / stride) + 1)) : 1;
        if (status) status.textContent = cards.length ? `Product ${first} of ${cards.length}` : '';
      }
      function move(direction) {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const stride = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        const visible = Math.max(1, Math.floor((track.clientWidth + 1) / Math.max(1, stride)));
        let target = track.scrollLeft + direction * Math.max(stride, visible * stride);
        if (direction > 0 && track.scrollLeft >= max - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = max;
        track.scrollTo({left: Math.max(0, Math.min(max, target)), behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();move(e.key === 'ArrowRight' ? 1 : -1);} });
      window.addEventListener('resize', update, {passive:true});
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      track.querySelectorAll('img').forEach(img => img.addEventListener('load', update, {once:true}));
      update();
    });

    scope.querySelectorAll('[data-quiz]:not([data-initialized])').forEach(quiz => {
      quiz.dataset.initialized = 'true';
      const form = quiz.querySelector('[data-quiz-form]');
      const steps = [...form.querySelectorAll('[data-quiz-step]')];
      if (!steps.length) return;
      const back = quiz.querySelector('[data-quiz-back]');
      const next = quiz.querySelector('[data-quiz-next]');
      const progress = quiz.querySelector('[data-quiz-progress]');
      const result = quiz.querySelector('[data-quiz-result]');
      let index = 0;
      function show() {
        steps.forEach((step, i) => { step.hidden = i !== index; step.querySelectorAll('input').forEach(input => input.required = i === index); });
        back.hidden = index === 0;
        next.textContent = index === steps.length - 1 ? 'See my guide →' : 'Continue →';
        progress.textContent = `${index + 1} of ${steps.length}`;
        const percent = Math.round((index + 1) / steps.length * 100);
        const meter = quiz.querySelector("[data-quiz-meter]");
        if (meter) meter.setAttribute("aria-valuenow", percent);
        const bar = quiz.querySelector("[data-quiz-bar]");
        if (bar) bar.style.width = `${percent}%`;
      }
      form.addEventListener('submit', e => {
        e.preventDefault();
        if (!form.reportValidity()) return;
        if (index < steps.length - 1) { index++; show(); steps[index].querySelector('input')?.focus(); }
        else {
          form.hidden = true; result.hidden = false;
          const values = steps.map(s => s.querySelector('input:checked')?.value).filter(Boolean);
          const time = values[0]?.toLowerCase() || '';
          const reminder = values[2] || '';
          quiz.querySelector('[data-quiz-summary]').textContent = `Your preferences: ${time}. ${reminder}. Use these preferences to choose a convenient reminder; always follow the product’s labeled directions.`;
          const heading = result.querySelector('h3'); heading.setAttribute('tabindex', '-1'); heading.focus();
        }
      });
      back.addEventListener('click', () => { index = Math.max(0, index - 1); show(); });
      quiz.querySelector('[data-quiz-reset]').addEventListener('click', () => { form.reset(); index = 0; form.hidden = false; result.hidden = true; show(); steps[0].querySelector('input')?.focus(); });
      show();
    });

    scope.querySelectorAll('[data-product-root]:not([data-initialized])').forEach(root => {
      root.dataset.initialized = 'true';
      const form = root.querySelector('.product-form');
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const price = root.querySelector('[data-price]');
      const addButton = root.querySelector('[data-add-button]');
      const status = root.querySelector('.form-status');
      const getVariant = () => variants.find(v => String(v.id) === String(new FormData(form).get('id')));
      const bundleSelector = '#pumper_bundle_svelte, .pumper-bundles';
      const sealSelector = '.sealsubs-target-element, .sealsubs-container, .sls-purchase-options-container';
      let lastBundleImage = '';
      let queued = false;
      let submitting = false;

      function setText(selector, value) {
        const node = price.querySelector(selector);
        if (node && node.textContent !== value) node.textContent = value;
      }
      function changeImage(src, alt) {
        if (!src) return;
        const img = root.querySelector('[data-main-image] img');
        if (!img) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        if (img.getAttribute('src') !== src) img.src = src;
        if (alt) img.alt = alt;
        // Match by image filename, ignoring Shopify's requested resolution.
        const key = url => { try { return new URL(url, location.href).pathname; } catch { return url; } };
        root.querySelectorAll('[data-gallery-src]').forEach(button => {
          button.setAttribute('aria-pressed', String(key(button.dataset.gallerySrc) === key(src)));
        });
      }
      function clearSubscriptions() {
        // These pages sell the selected Pumper offer as a one-time purchase.
        // Disable late-injected Seal fields as well as removing them from AJAX data.
        root.querySelectorAll(`${sealSelector}, [name="selling_plan"]`).forEach(node => {
          if (node.matches('[name="selling_plan"]')) {
            if (node.value) node.value = '';
            if (!node.disabled) node.disabled = true;
          } else {
            if (!node.hidden) node.hidden = true;
            node.querySelectorAll('input, select, button').forEach(field => {
              if (!field.disabled) field.disabled = true;
            });
          }
        });
      }
      function selectedTier() {
        const widget = root.querySelector(bundleSelector);
        if (!widget) return null;
        // Pumper v2 exposes the selected card. The frame also carries this flag.
        return widget.querySelector('.pmpr-tier-shell__card[data-selected="true"]') ||
          widget.querySelector('.pmpr-tier-shell__frame[data-selected="true"] .pmpr-tier-shell__card');
      }
      function moneyAmount(text) {
        // Used only for a savings fallback; display strings are copied from Pumper.
        const parts = String(text || '').replace(/[^\d.,]/g, '');
        if (!parts) return NaN;
        const decimal = parts.match(/[.,](\d{1,2})$/);
        return decimal ? Number(parts.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1]) : Number(parts.replace(/[.,]/g, ''));
      }
      function updatePrice() {
        clearSubscriptions();
        const v = getVariant(); if (!v) return;
        const tier = selectedTier();
        const total = tier?.querySelector('.pmpr-tier-price__total')?.textContent.trim();
        const original = tier?.querySelector('.pmpr-tier-price__compare')?.textContent.trim();
        const bundleActive = !!total;
        root.classList.toggle('has-bundle-offer', bundleActive);
        const picker = root.querySelector('.product-variant-picker');
        if (picker) picker.hidden = bundleActive;
        let current = v.price;
        let compareText = v.compare_price || '';
        let amount = Number(v.price_amount);
        let compare = Number(v.compare_amount);
        let savings;
        if (bundleActive) {
          current = total;
          compareText = original || '';
          amount = moneyAmount(total);
          compare = moneyAmount(original);
          const label = tier.querySelector('.pmpr-tier-label')?.textContent || '';
          const percent = label.match(/(\d+(?:[.,]\d+)?)\s*%/);
          if (percent) savings = Number(percent[1].replace(',', '.'));
          // Use the custom tier image, never a free gift or shipping icon.
          const image = tier.querySelector('.add-image__img');
          const src = image?.getAttribute('src') || v.image;
          const title = tier.querySelector('.pmpr-tier-title')?.textContent.trim() || v.title;
          const signature = `${title}|${src || ''}`;
          if (lastBundleImage !== signature) {
            changeImage(src, `${root.querySelector('h1').textContent.trim()} — ${title}`);
            lastBundleImage = signature;
          }
        } else if (lastBundleImage) {
          lastBundleImage = '';
          changeImage(v.image);
        }
        const hasDiscount = Number.isFinite(amount) && amount >= 0 && Number.isFinite(compare) && compare > amount;
        if (savings === undefined) savings = hasDiscount ? Math.round((compare - amount) / compare * 1000) / 10 : 0;
        setText('[data-price-current]', current);
        setText('[data-price-original]', compareText);
        price.querySelector('[data-price-compare]').hidden = !hasDiscount;
        price.querySelector('[data-price-save]').hidden = !hasDiscount || savings <= 0;
        setText('[data-price-savings]', `SAVE ${savings}%`);
        const canPurchase = v.available && !v.requires_plan;
        addButton.disabled = submitting || !canPurchase;
        const label = submitting ? 'Adding…' : !v.available ? 'Sold out' : !canPurchase ? 'Unavailable for one-time purchase' : 'Add to cart →';
        if (addButton.textContent !== label) addButton.textContent = label;
      }
      function scheduleSync() {
        if (queued || !root.isConnected) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; if (root.isConnected) updatePrice(); });
      }
      function updateVariant() {
        const v = getVariant(); if (!v) return;
        const caption = root.querySelector('[data-variant-caption]');
        if (caption) caption.textContent = v.title ? `— ${v.title}` : '';
        if (!selectedTier()) changeImage(v.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
        lastBundleImage = '';
        updatePrice();
      }
      form.addEventListener('change', event => {
        if (event.target.matches('[name="id"]')) updateVariant();
        else scheduleSync();
      });
      root.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
        changeImage(button.dataset.gallerySrc, button.dataset.galleryAlt);
      }));
      // Events are emitted by the installed Pumper v2 app. The observer also
      // covers delayed mounting, currency changes and re-rendered offer cards.
      ['prvw-option-selected', 'pumper-widget-ready', 'pumper:tierDomReady', 'prvw-recalculate-prices', 'pumper:v2:variant-picker:changed'].forEach(name => {
        window.addEventListener(name, scheduleSync);
        document.addEventListener(name, scheduleSync);
      });
      root.addEventListener('click', event => {
        if (event.target.closest(bundleSelector)) scheduleSync();
      });
      const observer = new MutationObserver(records => {
        if (!root.isConnected) { observer.disconnect(); return; }
        const relevant = records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return target?.closest(`${bundleSelector}, ${sealSelector}`) ||
            [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 &&
              (node.matches(`${bundleSelector}, ${sealSelector}, [name="selling_plan"]`) || node.querySelector(`${bundleSelector}, ${sealSelector}, [name="selling_plan"]`)));
        });
        if (relevant) scheduleSync();
      });
      observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['data-selected', 'src', 'srcset', 'value', 'checked', 'disabled']});
      form.addEventListener('submit', async e => {
        if (!window.fetch) return;
        e.preventDefault();
        if (submitting) return;
        updatePrice();
        if (!form.reportValidity() || addButton.disabled) return;
        submitting = true;
        updatePrice();
        status.textContent = 'Adding to your cart…';
        const data = new FormData(form);
        data.delete('selling_plan');
        const base = window.Shopify?.routes?.root || '/';
        try {
          // Call the current window.fetch: Pumper's installed proxy expands
          // the active offer into paid items, gifts and discount properties.
          const response = await window.fetch(`${base}cart/add.js`, {method: 'POST', body: data, headers: {Accept: 'application/json'}});
          const body = await response.json();
          if (!response.ok) throw new Error(body.description || body.message || 'Unable to add this item. Please try again.');
          status.textContent = 'Added. Opening your cart…';
          window.location.assign(`${base}cart`);
        } catch (error) {
          submitting = false;
          status.textContent = error.message;
          updatePrice();
        }
      });
      updateVariant();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();
// Legacy customer address country/province dependencies.
document.querySelectorAll('[data-address-country]').forEach(country => {
  const form = country.closest('form');
  const province = form.querySelector('[data-address-province]');
  if ([...country.options].some(o => o.value === country.dataset.default)) country.value = country.dataset.default;
  function updateProvince(initial) {
    let provinces = []; try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) { /* No province list. */ }
    province.replaceChildren(...provinces.map(([value, name]) => new Option(name, value)));
    const hasProvinces = provinces.length > 0;
    province.hidden = !hasProvinces; province.disabled = !hasProvinces;
    const label = form.querySelector(`label[for="${province.id}"]`); if (label) label.hidden = !hasProvinces;
    if (initial && provinces.some(([value]) => value === province.dataset.default)) province.value = province.dataset.default;
  }
  country.addEventListener('change', () => updateProvince(false)); updateProvince(true);
});
(() => {
 const dialog=document.querySelector('[data-cart-drawer]');
 if(!dialog || typeof dialog.showModal!=='function') return;
 let trigger;
 document.querySelectorAll('[data-cart-open]').forEach(link=>link.addEventListener('click',async e=>{
  e.preventDefault();trigger=link;dialog.showModal();
  const content=dialog.querySelector('[data-cart-content]');content.textContent='Loading your bag…';
  if(location.protocol==='file:'){content.textContent='This is a layout preview. Your live Shopify bag will appear here.';return;}
  try{const response=await fetch((window.Shopify?.routes?.root || '/')+'cart.js');if(!response.ok)throw Error();const cart=await response.json();content.replaceChildren();
   if(!cart.items.length)content.textContent='Your bag is waiting for something good.';
   cart.items.forEach(item=>{const row=document.createElement('div');row.className='drawer-item';const title=document.createElement('strong');title.textContent=item.product_title;const detail=document.createElement('p');detail.textContent=`${item.quantity} × ${new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:cart.currency}).format(item.final_price/100)}`;row.append(title,detail);content.append(row);});
   if(cart.items.length){const total=document.createElement('p');total.textContent='Subtotal: '+new Intl.NumberFormat('en',{style:'currency',currency:cart.currency}).format(cart.total_price/100);content.append(total);}
  }catch{content.textContent='Your bag could not load. Use the button below to open the cart page.';}
 }));
 dialog.querySelector('[data-cart-close]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',e=>{if(e.target===dialog && e.clientX<dialog.getBoundingClientRect().left)dialog.close();});
 dialog.addEventListener('close',()=>trigger?.focus());
})();
